export const userRoute = {
  USER_LIST: '/user/list',
  USER_DETAIL: '/user/detail/:recordId',
};
